<div class="flex flex-col">
  <span class="text-2xl font-bold mb-2">{{ 'JOB_MANAGEMENT.TITLE' | transloco }}</span>
  <span class="mb-4">{{ 'JOB_MANAGEMENT.SUBTITLE' | transloco }}</span>
  <mat-card appearance="outlined" class="p-0">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" fitInkBarToContent animationDuration="0ms">
      <a
        mat-tab-link
        *ngFor="let tab of tabs$ | async"
        (click)="changeTab(tab.value)"
        [active]="isActive(tab.value)"
        class="font-bold"
      >
        {{ tab?.title | transloco }}
      </a>
    </nav>
    <mat-divider></mat-divider>
    <mat-tab-nav-panel #tabPanel>
      <app-job-list
        [searchTerm]="searchTerm$ | async"
        [items]="items$ | async"
        [selectAddJobButtonLabel]="selectAddJobButtonLabel$ | async"
        [selectEmptyListMessage]="selectEmptyListMessage$ | async"
        [loading]="loading$ | async"
        (filterEvent)="updateSearchTerm($event)"
        (openDialog)="openDialog($event)"
        (deleteItem)="onDelete($event)"
      ></app-job-list>
    </mat-tab-nav-panel>
  </mat-card>
</div>
